// extracted by mini-css-extract-plugin
export default {"intro_top_bg":"intropage_intro_top_bg__bYc2Z","intro_contents":"intropage_intro_contents__HbRyn"};